module.exports = __webpack_public_path__ + "static/media/02.59628f96.png";